import { call, put, takeLatest } from 'redux-saga/effects'
import { USER_RESOURCES_FETCH_REQUESTED, USER_RESOURCES_FETCH_SUCCEEDED, USER_RESOURCES_FETCH_FAILED } from "../actionTypes"
import { getUserResources } from '../../services/powerBIService'

function* fetchUserResources(action: any){
    try {
        const userResources = yield call(getUserResources, action.payload.bearerToken)
        yield put({type: USER_RESOURCES_FETCH_SUCCEEDED, payload: {resources: userResources}})
    } catch (error) {
        yield put({type: USER_RESOURCES_FETCH_FAILED, payload : {resourceMessage: error.message}});
    }
}

function* userResourcesSaga(){
    yield takeLatest(USER_RESOURCES_FETCH_REQUESTED, fetchUserResources)
}

export default userResourcesSaga